// React Components
import { useState, useContext, useEffect } from "react";
import Axios from "axios";
// Own Components
import Banner from "../Components/Banner";
import StateContext from "../StateContext";
// React Router Components
import { Link, useHistory } from "react-router-dom";
// Mui Components
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withTranslation, useTranslation } from "react-i18next";

import {
  Select,
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  InputAdornment,
  TextField,
} from "@material-ui/core/";
import clsx from "clsx";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { CountryCode } from "../Components/CountryCode";
import DispatchContext from "../DispatchContext";
import kuwaitFlag from "../Assets/images/kuiwat flag.png";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    width: "100%",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Register() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const [isLoading, setIsLoading] = useState(false);
  let [registered] = useState(false);
  const [, setCountryCodeValues] = useState([]);
  const { t } = useTranslation();

  const [genderList] = useState([
    {
      name: "gender",
      gender: "Male",
    },
    {
      name: "gender",
      gender: "Female",
    },
    {
      name: "gender",
      gender: "Other",
    },
  ]);

  useEffect(() => {
    const codeValues = async () => {
      var code =  CountryCode();
      setCountryCodeValues(code);
      // console.log("codes...", code);
    };
    codeValues();
  }, []);

  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  let history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [cShowPassword, setCShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(true);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(false);
  };
  const handleClickCShowPassword = () => {
    setCShowPassword(true);
  };

  const handleMouseCDownPassword = () => {
    setCShowPassword(false);
  };

  

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  const [, setSelectedDate] = useState({});
  const handleDateChange = async (date) => {
    let new_date = new Date(date);
    // console.log('get date', new_date)
    let year = new_date.getFullYear();
    let month = new_date.getMonth();
    month++;
    let day = new_date.getDate();
    setSelectedDate(`${year}/${month}/${day}`);
    setRegisterValues({ ...RegisterValues, dob: `${year}/${month}/${day}` });
  };

  const [RegisterValues, setRegisterValues] = useState([{}]);
  const updateField = (prop) => (event) => {
    // console.log(prop + ":" + event.target.value);
    setRegisterValues({ ...RegisterValues, [prop]: event.target.value });
  };
  // console.log(RegisterValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      RegisterValues.first_name &&
      RegisterValues.middle_name &&
      RegisterValues.last_name &&
      RegisterValues.email &&
      RegisterValues.password &&
      RegisterValues.gender &&
      RegisterValues.dob &&
      RegisterValues.confirm_password &&
      RegisterValues.number !== ""
    ) {

      let emailValidation = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailValidation.test(RegisterValues.email)) {
        setAlertMessage({
          open: true,
          message: t("form.Email-Format"),
          alertSuccess: false,
        });
        setLoading(false);
        return;
      }
      if (
        RegisterValues.number.length >= 7 &&
        RegisterValues.number.length < 15
      ) {
        if (RegisterValues.password === RegisterValues.confirm_password) {
          Axios.post(`${process.env.REACT_APP_API_URL}customer/register`, {
            first_name: RegisterValues.first_name,
            last_name: RegisterValues.middle_name,
            middle_name: RegisterValues.last_name,
            email: RegisterValues.email,
            password: RegisterValues.password,
            gender: RegisterValues.gender,
            country_code: "965",
            number: RegisterValues.number,
            dob: RegisterValues.dob,
          })
            .then((response) => {
              if (response.status === 200) {
                if (response.data.success === true) {
                  setAlertMessage({
                    open: true,
                    message: response.data.message,
                    alertSuccess: response.data.success,
                  });
                  setLoading(false);
                  setTimeout(() => {
                    history.push(`/`);
                  }, 3000);
                } else {
                  setAlertMessage({
                    open: true,
                    message: response.data.data,
                    alertSuccess: response.data.success,
                  });
                  setLoading(false);
                }
              } else {
                setAlertMessage({
                  open: true,
                  message: t("form.Something-wrong"),
                  alertSuccess: false,
                });
                return;
              }
            })
            .catch((e) => {
              setLoading(false);
              setAlertMessage({
                open: true,
                message: e.response,
                alertSuccess: false,
              });
              return;
            });
        } else {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: t("form.pass-not-found"),
            alertSuccess: false,
          });

          return;
        }
      } else {
        setLoading(false);
        setAlertMessage({
          open: true,
          message: t("form.correct-mobile"),

          alertSuccess: false,
        });
        return;
      }
    } else {
      setAlertMessage({
        open: true,
        message: t("form.plz-fill"),
        alertSuccess: false,
      });
      setLoading(false);
      return;
    }
  };

  // localization  start

  const arLanguageHandle = (e) => {
    // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };

  // localixatio end

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage({ open: false, message: "", alertSuccess: false });
    }, 3000);
    if (registered) {
      setIsLoading(true);
      history.push(`/`);
    }
  }, [alertMessage.open]);
  if (appState.loggedIn) {
    history.push("/dashboard");

  }
  if (isLoading) {
    return "loading..";
  } else {
    return (
      <>
        {/* Header */}
        <div className="RegisterHeader">
          <Banner
            message_secondary={`${t("form.Welcome")}!`}
            className="bannerLogin"
          />
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alertMessage.open}
          className={
            alertMessage.alertSuccess ? "success-alert" : "danger-alert"
          }
        >
          {alertMessage.alertSuccess ? (
            <Alert severity="success">{alertMessage.message}</Alert>
          ) : (
            <Alert severity="error">{alertMessage.message}</Alert>
          )}
        </Snackbar>

        <div  className={`${loading ? "pointer-events-none" :""} RegisterMainArea text-center`}>
          <div className="container col-12     ">
            <h2>
              <span className="text-primary">{t("form.register-your")}</span>
              <span className="text-secondary">
                {" "}
                <strong> {t("form.Account")}</strong>
              </span>
            </h2>
            <form action="" onSubmit={handleSubmit}>
              <div className="row m-0 justify-content-center w-80">
                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-4 col-sm-4 mx-auto mt-3`}
                >
                  <TextField
                    id="register_fname"
                    name="first_name"
                    value={RegisterValues.first_name}
                    onChange={updateField("first_name")}
                    type="text"
                    className="w-100"
                    label={t("form.First-Name")}
                  />
                </div>
                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-4 col-sm-4 mx-auto mt-3`}
                >
                  <TextField
                    id="register_mname"
                    name="middle_name"
                    value={RegisterValues.middle_name}
                    onChange={updateField("middle_name")}
                    type="text"
                    className="w-100"
                    label={t("form.Middle-Name")}
                  />
                </div>
                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-4 col-sm-4 mx-auto mt-3`}
                >
                  <TextField
                    id="register_lname"
                    name="last_name"
                    value={RegisterValues.last_name}
                    onChange={updateField("last_name")}
                    type="text"
                    className="w-100"
                    label={t("form.Last-Name")}
                  />
                </div>

                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-6 col-sm-6 mx-auto mt-3`}
                >
                  <TextField
                    id="register_email"
                    name="email"
                    required
                    value={RegisterValues.email}
                    onChange={updateField("email")}
                    type="email"
                    className="w-100"
                    label={t("form.Email")}
                  />
                </div>

                <div
                  className={`${
                    appState.langValue === "ar"
                      ? "profileformRtlRegisterGender"
                      : ""
                  } col-sm-6 mx-auto mt-3`}
                >
                  <TextField
                    type="number"
                    inputProps={{ maxLength: 8 }}
                    onChange={updateField("number")}
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 8);
                    }}
                    name="number"
                    required
                    className={
                      appState.langValue == "ar"
                        ? "ml-3 required contact-field"
                        : "mr-3 required contact-field"
                    }
                    value={RegisterValues.number}
                    label={t("form.Phone-No")}
                    className="w-100"
                    id="phone_no"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="">
                          <div className="d-flex align-items-center">
                            <img
                              src={kuwaitFlag}
                              alt="kuwaitFlag"
                              height="25px"
                            />

                            <p className="ml-1 mt-3">+965</p>
                          </div>
                        </InputAdornment>
                      ),
                    }}

                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">

                    //       <FormControl
                    //         className={`d-flex ${classes.formControl}`}
                    //       >
                    //         <Select
                    //           labelId="demo-simple-select-label"
                    //           id="demo-simple-select"
                    //           value={
                    //             RegisterValues.country_code != ""
                    //               ? RegisterValues.country_code
                    //               : 956
                    //           }
                    //           onChange={updateField("country_code")}
                    //         >
                    //           <MenuItem value="None">
                    //             <em>None</em>
                    //           </MenuItem>
                    //           {countryCodeValues.map((val, ind) => (
                    //             <MenuItem value={val.code}>
                    //               <span> {val.name} </span> &nbsp; {val.code}
                    //             </MenuItem>
                    //           ))}
                    //         </Select>
                    //       </FormControl>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                  {/* <MuiPhoneNumber 
                      defaultCountry="kw"
                      preferredCountries={['middle-east']}
                      // ['middle-east'],
                      // // 'kw',
                      // className="w-100"
                    label="code"
                     /> */}
                </div>
                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-6 col-sm-6 mx-auto  pt-3 d-flex`}
                >
                  <TextField
                    id="dob-field"
                    name="dob"
                    value={RegisterValues.dob}
                    onChange={updateField("dob")}
                    type="date"
                    className="w-100 DoB"
                    label={t("form.dob")}
                    required
                    id="phone_no"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className=""
                        ></InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } d-flex col-md-6 col-sm-6 mx-auto mt-3`}
                >
                  <FormControl className={`d-flex ${classes.formControl}`}>
                    <InputLabel
                      id="demo-simple-select-label"
                      className="d-flex "
                    >
                      {t("form.gender")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      name="gender"
                      id="demo-simple-select"
                      value={RegisterValues.gender}
                      onChange={updateField("gender")}
                    >
                      <MenuItem value="None">
                        <em>None</em>
                      </MenuItem>
                      {genderList.map((val, ind) => (
                        <MenuItem value={val.gender.toLocaleLowerCase()} key={val.name}>
                          {val.gender}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-6 col-sm-6 mx-auto mt-3`}
                >
                  <TextField
                    id="register_password"
                    name="password"
                    value={RegisterValues.password}
                    onChange={updateField("password")}
                    type={showPassword != true ? "password" : "text"}
                    className="w-100"
                    label={t("form.password")}
                    InputProps={{
                
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                       style={{height:"100%",padding:"20px 14px 20px 13px"}}
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {!showPassword ? (
                              <div >
                                <VisibilityOff />
                              </div>
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div className="text-left">
                    <p className="text-muted small">
                      * {t("form.Password-should-be")}
                    </p>
                  </div>
                </div>
                <div
                  className={`${
                    appState.langValue === "ar" ? "profileformRtl" : ""
                  } col-md-6 col-sm-6 mx-auto mt-3`}
                >
                  <TextField
                    id="register_confirm_password"
                    name="confirmPassword"
                    value={RegisterValues.confirmPassword}
                    onChange={updateField("confirm_password")}
                    type={cShowPassword != true ? "password" : "text"}
                    className="w-100"
                    label={t("form.confirm-pass")}
                    InputProps={{
                
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                       style={{height:"100%",padding:"20px 14px 20px 13px"}}
                            aria-label="toggle password visibility"
                            onClick={handleClickCShowPassword}
                            onMouseDown={handleMouseCDownPassword}
                            edge="end"
                          >
                            {!cShowPassword ? (
                              <div >
                                <VisibilityOff />
                              </div>
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  
                  />
                </div>

                <div className="col-12 LoginButtonContainer text-center">
                  <div className={classes.root}>
                    <div className={classes.wrapper}>
                      <Button
                        variant="contained"
                        type="submit"
                        className={`${buttonClassname} bg-primary login_btn mt-4`}
                      >
                        {loading ? t("form.loading") : t("form.register")}
                      </Button>
                      {loading && (
                        <CircularProgress
                          size={24}
                          className={`${classes.buttonProgress}  mt-1`}
                        />
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <p className="small text-muted">
                      {t("form.already-account")}?{" "}
                      <Link to={`/`} className="text-primary">
                        {t("login.Login")}?{" "}
                      </Link>
                      <br />
                      {appState.langValue === "ar" ? (
                        <span
                          onClick={(e) => enLanguageHandle(e)}
                          className="cursor-pointer text-primary "
                        >
                          English
                        </span>
                      ) : (
                        <span
                          onClick={(e) => arLanguageHandle(e)}
                          className="cursor-pointer text-primary"
                        >
                          Arabic
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(Register);
